import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { ParamsVendas } from '../models/params-vendas';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ParamsVendasService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) {}

  getParams(cnpj: string): Observable<ParamsVendas> {
    if (cnpj === '') {
      return of();
    }

    return this.http.get<ParamsVendas>(environment.vendas + '/params/' + cnpj).pipe(catchError(err => of(err.err)));
  }

  updateParams(cnpj: string, params: ParamsVendas): Observable<ParamsVendas> {
    if (cnpj === '') {
      return of();
    }

    return this.http
      .put<ParamsVendas>(environment.vendas + '/params/' + cnpj, params, this.httpOptions)
      .pipe(catchError(err => of(err.err)));
  }
}
